import { DynamicIcon, IconName } from "lucide-react/dynamic";

import Coldwave from "@/assets/images/icons/icon_coldwave.svg";
import Fog from "@/assets/images/icons/icon_fog.svg";
import Gusts from "@/assets/images/icons/icon_gusts.svg";
import Heatwave from "@/assets/images/icons/icon_heatwave.svg";
import Lightning from "@/assets/images/icons/icon_lightning.svg";
import Rainfall from "@/assets/images/icons/icon_rainfall.svg";
import SlipperySnow from "@/assets/images/icons/icon_slipperysnow.svg";
import Snow from "@/assets/images/icons/icon_snow.svg";
import Airplane from "@/assets/images/icons/icon_airplane.svg";
import AirBalloon from "@/assets/images/icons/icon_airballoon.svg";
import Glider from "@/assets/images/icons/icon_glider.svg";
import Helicopter from "@/assets/images/icons/icon_helicopter.svg";

import styles from "./icon.module.css";

const customIcons = {
  airballoon: <AirBalloon />,
  airplane: <Airplane />,
  coldwave: <Coldwave />,
  fog: <Fog />,
  glider: <Glider />,
  gusts: <Gusts />,
  heatwave: <Heatwave />,
  helicopter: <Helicopter />,
  lightning: <Lightning />,
  rainfall: <Rainfall />,
  slipperysnow: <SlipperySnow />,
  snow: <Snow />,
} as const;

export type CustomIconName = keyof typeof customIcons;
export type IconNames = IconName | CustomIconName;
export const customIconNames = Object.keys(customIcons) as CustomIconName[];

interface IconProps {
  name: IconName | CustomIconName;
  size?: number;
  strokeWidth?: number;
}

export function Icon({ name, strokeWidth = 1.5, size = 24 }: IconProps) {
  if (name in customIcons) {
    const icon = customIcons[name as CustomIconName];
    if (typeof icon === "string")
      return (
        <img
          src={`${customIcons[name as CustomIconName]}`}
          style={{ width: size, aspectRatio: 1 }}
        />
      );

    return (
      <div className={styles.customIcon} style={{ width: size, strokeWidth }}>
        {icon}
      </div>
    );
  }

  return (
    <DynamicIcon
      strokeWidth={strokeWidth}
      name={name as IconName}
      size={size}
      className={styles.icon}
    />
  );
}
export default Icon;
